export enum VillasContentSections {
    OVERVIEW = 'overview',
    ROOMS_AND_AMENITIES = 'rooms-and-amenities',
    LOCATION = 'location',
    REVIEWS = 'reviews',
    THINGS_TO_KNOW = 'things-to-know',
  }
